var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"NewView"}},[_c('div',{ref:"newView-content",attrs:{"id":"newView-content"}},[_vm._v(_vm._s(_vm.notice.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }